export const USER_GROUP_VALUES = {
  LOGGED_CUSTOMER: 'LOGGEDCUSTOMER',
  LOGGED_MERCHANT: 'LOGGEDMERCHANT',
  LOGGED_STAFF: 'LOGGEDSTAFF',
  GUEST_CUSTOMER: 'GUESTCUSTOMER',
  NOT_LOGGED: 'NOTLOGGED',
}

export const USER_GROUP_NAME = 'user_type'

export const AMPLITUDE_DEVICE_ID_STATE_KEY = 'amplitude-device-id'

export const AMPLITUDE_SESSION_ID_STATE_KEY = 'amplitude-session-id'

export const FORWARDED_AMPLITUDE_DEVICE_ID_STATE_KEY =
  'forwarded-amplitude-device-id'
